import React, { useState, useEffect, useCallback } from "react";
import { API_URL } from "../../utils/config";
import { mapToPresentable, mapejos } from "../../utils/Mapejos";
import { useUserContext } from "../../utils/UserContext";
import { tincPermis } from "../../utils/Permisos";
import TeclaEscEnter from "../../utils/Teclaescenter";
import { formatAddress, formatDate } from "../../utils/Utilitats";
// Importaries el teu component de cerca, similar a Seleccionarpressupost, per ex.:
import Seleccionartreball from "./Seleccionartreball";
import AjudaTreball from "./AjudaTreball";


function aDataISO(valor) {
  return valor ? String(valor).slice(0, 10) : "";
}

function avuiLocalISO() {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

/**
 * mode: "nou" | "consultar" | "modificar" | "esborrar"
 * treball: objecte que conté les dades del treball (si n'hi ha)
 * treballs: array de treballs filtrats per navegar
 * onNavigate: funció callback per navegar entre treballs
 * onSave: funció callback quan es desa (crear o modificar)
 * onCancel: funció callback quan es cancel·la o es tanca
 */
function Detallstreball({
  mode,
  treball,
  treballs,
  onNavigate,
  onSave,
  onCancel,
  subnav,
  onCanviarMode,
  clientInicial,
  onNouClient,
}) {
  // Per saber si estem en mode consulta o esborrar, no deixem editar
  const isReadOnly = mode === "consultar" || mode === "esborrar";
  const [menuAccions, setMenuAccions] = useState(false);
  const [mostraAjuda, setMostraAjuda] = useState(false);

  // Per tancar amb ESC o Enter (si vols)
  TeclaEscEnter(onCancel, null);

  // =================== NAV ENTRE TREBALLS ===================
  const currentIndex = Array.isArray(treballs)
    ? treballs.findIndex((t) => t.idTreballs === treball?.idTreballs)
    : -1;

  const anteriorTreball = () => {
    if (!Array.isArray(treballs) || treballs.length === 0 || currentIndex < 0) return;
    const newIndex = currentIndex === 0 ? treballs.length - 1 : currentIndex - 1;
    onNavigate?.(treballs[newIndex]);
  };

  const seguentTreball = () => {
    if (!Array.isArray(treballs) || treballs.length === 0 || currentIndex < 0) return;
    const newIndex = currentIndex === treballs.length - 1 ? 0 : currentIndex + 1;
    onNavigate?.(treballs[newIndex]);
  };

  // Context de l’empresa seleccionada i usuari
  const { empresaSeleccionada, usuariActiu, rolUsuari } = useUserContext();
  const pucCrear = tincPermis(rolUsuari, "CREAR");
  const pucModificar = tincPermis(rolUsuari, "MODIFICAR");
  const pucEsborrarFitxa = tincPermis(rolUsuari, "ESBORRAR");

  // =================== ESTATS / 1ª LÍNIA ===================
  // Client
  const [clientId, setClientId] = useState(null);
  const [clientsOptions, setClientsOptions] = useState([]);
  const [filtreClient, setFiltreClient] = useState("");
  const [clientsFiltrats, setClientsFiltrats] = useState([]);
  // Contacte de Client
  const [contactesClient, setContactesClient] = useState([]);
  const [contacteClientSeleccionat, setContacteClientSeleccionat] = useState(null);

  // Treball relacionat (cercador / lupa)
  const [treballRelId, setTreballRelId] = useState(null);
  const [treballRel, setTreballRel] = useState(null);
  const [treballsClient, setTreballsClient] = useState([]);
  const [seleccioTreball, setSeleccioTreball] = useState(false);
  const [selectedTreball, setSelectedTreball] = useState(null);
  // Podries guardar objectes sencers si vols, depenent de com implementis Seleccionartreballs


  // =================== ESTATS / 2ª LÍNIA (Contacte de Treball) ===================
  // Nom/tel/email del Contacte no s'editen aquí. Alta possible; edició global pendent
  // d'una pantalla comuna (l'alta avui es fa des de diversos punts).
  const [contactesTreball, setContactesTreball] = useState([]);
  // Camps “Nom, Telèfon, Email” del contacte de treball
  const [nomContacteTreball, setNomContacteTreball] = useState("");
  const [telefonContacteTreball, setTelefonContacteTreball] = useState("");
  const [emailContacteTreball, setEmailContacteTreball] = useState("");

  // =================== ESTATS / 3ª LÍNIA (Rol, Notes, Professió) ===================
  const [rolContacteTreball, setRolContacteTreball] = useState("");
  const [notesContacteTreball, setNotesContacteTreball] = useState("");

  // PROFESSIÓ
  const [professio, setProfessio] = useState(null);
  const [professioDescripcio, setProfessioDescripcio] = useState("");
  const [professionsOptions, setProfessionsOptions] = useState([]);
  const [filteredOptionsProfessions, setFilteredOptionsProfessions] = useState([]);
  const [showDropdownProfessions, setShowDropdownProfessions] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [description, setDescription] = useState("");
  const [isModification, setIsModification] = useState("");
  const [newDescription, setNewDescription] = useState("");

  // =================== ESTATS / 4ª LÍNIA (Rol, Notes, Professió) ===================
  const [tipusTreball, setTipusTreball] = useState("");
  const [tipusOptions, setTipusOptions] = useState([]);
  const [estatTreball, setEstatTreball] = useState("");
  const [estatOptions, setEstatOptions] = useState([]);


  // =================== ESTATS / 4ª-7ª LÍNIES (Adreça) ===================
  // Aquests són els camps d’adreça definitius al “Treball”
  // que l’usuari podrà modificar i que podem omplir amb l’adreça del client o treballRel si s’escau
  const [tipusVia, setTipusVia] = useState("");
  const [nomVia, setNomVia] = useState("");
  const [numVia, setNumVia] = useState("");
  const [escalaVia, setEscalaVia] = useState("");
  const [pis, setPis] = useState("");
  const [porta, setPorta] = useState("");
  const [poblacio, setPoblacio] = useState("");
  const [provincia, setProvincia] = useState("");
  const [pais, setPais] = useState("");
  const [codiPostal, setCodiPostal] = useState("");
  const [referencies, setReferencies] = useState("");


  // Estats per guardar els valors per defecte de l'adreça del client o treballRel
  const [tipusViaDefault, setTipusViaDefault] = useState("");
  const [nomViaDefault, setNomViaDefault] = useState("");
  const [numViaDefault, setNumViaDefault] = useState("");
  const [escalaViaDefault, setEscalaViaDefault] = useState("");
  const [pisDefault, setPisDefault] = useState("");
  const [portaDefault, setPortaDefault] = useState("");
  const [poblacioDefault, setPoblacioDefault] = useState("");
  const [provinciaDefault, setProvinciaDefault] = useState("");
  const [paisDefault, setPaisDefault] = useState("");
  const [codiPostalDefault, setCodiPostalDefault] = useState("");
  const [referenciesDefault, setReferenciesDefault] = useState("");

  // Estat per detectar si s'ha modificat manualment algun camp d'adreça
  const [adrecaModificada, setAdrecaModificada] = useState(false);

  // =================== ESTATS / 8ª LÍNIA ===================
  const [prioritatsOptions, setPrioritatsOptions] = useState([]);
  const [prioritatTreball, setPrioritatTreball] = useState("");
  const [dataIniciPrevista, setDataIniciPrevista] = useState("");
  const [dataFinalPrevista, setDataFinalPrevista] = useState("");
  const [dataInici, setDataInici] = useState("");
  const [dataFinal, setDataFinal] = useState("");
  const [tasquesCoherencia, setTasquesCoherencia] = useState([]);

  // =================== ESTATS / 9ª LÍNIA ===================
  const [descripcio, setDescripcio] = useState("");
  const [horari, setHorari] = useState("");

  // =================== ESTATS LEGACY/AUX (Recuperats per errors 'no-undef') ===================
  // Necessaris per compatibilitat amb codi existent que no s'ha refactoritzat del tot o que encara s'usa
  const [cognomContacteTreball, setCognomContacteTreball] = useState(""); // Potser usar per display o mappings
  const [vincularContacteClient, setVincularContacteClient] = useState(false); // Checkbox vinculació client nou
  const [modificarAdrecaContacte, setModificarAdrecaContacte] = useState(false); // Checkbox adreça per contacte client

  // =================== ESTATS NOUS (Refactor) ===================
  // 1. Nou Contacte Client (Empresa)
  const [nouContacteClientActiu, setNouContacteClientActiu] = useState(false);
  const [showDeleteTreballModal, setShowDeleteTreballModal] = useState(false);
  const [nomNouContacteClient, setNomNouContacteClient] = useState("");
  const [cognom1NouContacteClient, setCognom1NouContacteClient] = useState("");
  const [cognom2NouContacteClient, setCognom2NouContacteClient] = useState("");
  const [telefonNouContacteClient, setTelefonNouContacteClient] = useState("");
  const [emailNouContacteClient, setEmailNouContacteClient] = useState("");

  // 2. Contacte Coordinació
  const [coordinacioActiu, setCoordinacioActiu] = useState(false);
  const [nomCoordinacio, setNomCoordinacio] = useState("");
  const [cognom1Coordinacio, setCognom1Coordinacio] = useState("");
  const [cognom2Coordinacio, setCognom2Coordinacio] = useState("");
  const [telefonCoordinacio, setTelefonCoordinacio] = useState("");
  const [emailCoordinacio, setEmailCoordinacio] = useState("");
  const [rolCoordinacio, setRolCoordinacio] = useState("");
  const [vincularAdrecaCoordinacio, setVincularAdrecaCoordinacio] = useState(false);
  const [professioCoordinacio, setProfessioCoordinacio] = useState(null);
  const [contactesEmpresa, setContactesEmpresa] = useState([]);
  const [filtrePreferent, setFiltrePreferent] = useState("");
  const [idPreferentExistent, setIdPreferentExistent] = useState("");
  const [indicarAdrecaPreferent, setIndicarAdrecaPreferent] = useState(false);
  const [adrecaPreferent, setAdrecaPreferent] = useState({
    TipusVia: "", NomVia: "", NumVia: "", EscalaVia: "", Pis: "", Porta: "",
    Poblacio: "", Provincia: "", Pais: "Espanya", CodiPostal: "", Referencies: "",
  });

  // Constants de validació (opcional, per netedat)
  const isEmpresa = clientsOptions.find(c => c.idClients === clientId)?.TipusClient === "Empresa"; // Aproximació logic

  // Dedup Modal & Logic
  const [showDedupModal, setShowDedupModal] = useState(false);
  const [dedupContactes, setDedupContactes] = useState([]);
  const [dedupEntitats, setDedupEntitats] = useState([]); // (Opcional, si busquem entitats)
  const [dedupContext, setDedupContext] = useState(null); // 'client' | 'coordinacio' (tot i que coordinació és auto)
  const [resolvedContacteClient, setResolvedContacteClient] = useState(null); // Dades o ID per enviar
  const [resolvedContacteCoordinacio, setResolvedContacteCoordinacio] = useState(null); // Dades o ID per enviar

  // =================== EFECTES: CÀRREGA DE DADES ===================
  // 1) Carrega llista de Clients
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const resp = await fetch(`${API_URL}/Clientsempresaselect.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idEmpresa: empresaSeleccionada?.IdEmpresa || 0 }),
        });
        const data = await resp.json();
        if (data.success) {
          setClientsOptions(data.clients || []);
        } else {
          console.error("Error carregant clients:", data.message);
        }
      } catch (err) {
        console.error("Error al fetchClients:", err);
      }
    };
    fetchClients();
  }, [empresaSeleccionada]);

  useEffect(() => {
    if (mode !== "nou" || !empresaSeleccionada?.IdEmpresa) return;
    const fetchContactesEmpresa = async () => {
      try {
        const resp = await fetch(`${API_URL}/Contactes.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idEmpresa: empresaSeleccionada.IdEmpresa }),
        });
        const data = await resp.json();
        if (data.success) setContactesEmpresa(data.contactes || []);
      } catch (err) {
        console.error("Error carregant contactes de l'empresa:", err);
      }
    };
    fetchContactesEmpresa();
  }, [mode, empresaSeleccionada]);

  // 1b) Filtrar clients segons el text del filtre
  useEffect(() => {
    if (!filtreClient.trim()) {
      setClientsFiltrats(clientsOptions);
    } else {
      const textBusca = filtreClient.toLowerCase();
      const filtrats = clientsOptions.filter((cli) =>
        cli.NomClient?.toLowerCase().includes(textBusca) ||
        cli.CIF_DNI?.toLowerCase().includes(textBusca) ||
        cli.TelefonMobil?.toLowerCase().includes(textBusca) ||
        cli.TelefonFixe?.toLowerCase().includes(textBusca) ||
        cli.Email1?.toLowerCase().includes(textBusca)
      );
      setClientsFiltrats(filtrats);
    }
  }, [filtreClient, clientsOptions]);

  // 2) Carrega llista de Prioritats (en l’ENUM o taula Prioritattreballs.php)
  useEffect(() => {
    const fetchPrioritats = async () => {
      try {
        const resp = await fetch(`${API_URL}/Prioritattreballs.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
        });
        const data = await resp.json();
        if (data.success) {
          setPrioritatsOptions(data.prioritats || []);
        } else {
          console.error("Error carregant prioritats:", data.message);
        }
      } catch (err) {
        console.error("Error al fetchPrioritats:", err);
      }
    };
    fetchPrioritats();
  }, []);

  // 3) Carrega llista de professions

  const fetchProfessions = async () => {
    try {
      const resp = await fetch(`${API_URL}/Tipusprofessions.php`);
      const data = await resp.json();
      if (data.success) {
        setProfessionsOptions(data.data || []);
      } else {
        console.error("Error carregant professions:", data.message);
      }
    } catch (err) {
      console.error("Error en fetchProfessions:", err);
    }
  };

  useEffect(() => {
    fetchProfessions();
  }, []);

  // 4) Carrega llista de tipus de treball
  useEffect(() => {
    const fetchTipusTreball = async () => {

      try {
        const resp = await fetch(`${API_URL}/Tipustreball.php`);
        const data = await resp.json();
        if (data.success) {
          setTipusOptions(data.tipus || []);
        } else {
          console.error("Error carregant tipus de treball:", data.message);
        }
      } catch (err) {
        console.error("Error en fetchTipusTreball:", err);
      }
    };
    fetchTipusTreball();
  }, []);

  // 4) Carrega llista de tipus de treball
  useEffect(() => {
    const fetchEstatsTreball = async () => {

      try {
        const resp = await fetch(`${API_URL}/Estattreball.php`);
        const data = await resp.json();
        if (data.success) {
          setEstatOptions(data.estats || []);
        } else {
          console.error("Error carregant Estat de treball:", data.message);
        }
      } catch (err) {
        console.error("Error en fetchEstatTreball:", err);
      }
    };
    fetchEstatsTreball();
  }, []);


  // 4) Quan canvia el client, carreguem els contactes del client (com a Pressupost)
  // Quan canvia client, a més de contactes, carreguem també els seus treballs
  useEffect(() => {
    const fetchContactesAndTreballsClient = async () => {
      if (!clientId) {
        setContactesClient([]);
        setContacteClientSeleccionat(null);
        setTreballsClient([]);
        setTreballRel(null);
        setTreballRelId(null);
        return;
      }
      try {
        // 1) Carrega contactes
        const respContactes = await fetch(`${API_URL}/Contactesclient.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idClients: clientId }),
        });
        const dataC = await respContactes.json();
        if (dataC.success) {
          setContactesClient(dataC.contactes || []);
          setContacteClientSeleccionat(null);
        } else {
          console.error("Error carregant contactes client:", dataC.message);
          setContactesClient([]);
        }

        // 2) Carrega treballs del client
        const respTreballs = await fetch(`${API_URL}/Treballs.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada.IdEmpresa,
            idClient: clientId
          }),  // Paràmetre que la teva API esperi
        });
        const dataT = await respTreballs.json();
        if (dataT.success) {
          setTreballsClient(dataT.treballs || []);
        } else {
          console.error("Error carregant treballs del client:", dataT.message);
          setTreballsClient([]);
        }

        // A més, si no hem editat adreça manual ni tenim un treballRel, omplim adreça client
        if (!adrecaModificada && !treballRelId) {
          const clientSel = clientsOptions.find(c => c.idClients === clientId);
          if (clientSel) {
            inicialitzarAdrecaClient(clientSel);
          }
        }
      } catch (err) {
        console.error("Error al fetchContactesAndTreballsClient:", err);
        setContactesClient([]);
        setTreballsClient([]);
      }
    };

    fetchContactesAndTreballsClient();
  }, [clientId, adrecaModificada, treballRelId, clientsOptions]);


  // 6) Quan l'usuari tria un treball relacionat en un alta, copiem adreça per defecte
  useEffect(() => {
    if (mode === "nou" && treballRel && !adrecaModificada) {
      inicialitzarAdrecaTreballRel(treballRel);
    }

    // Contactes del Treball relacionat (Preferent → CLIENT amb id més baix)
    const fetchContactesTreball = async () => {
      if (!treballRel) {
        setContactesTreball([]);
        return;
      }
      try {
        const resp = await fetch(`${API_URL}/ContactesTreball.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idTreballs: treballRelId,
            idEmpresa: empresaSeleccionada?.IdEmpresa,
          }),
        });
        const data = await resp.json();
        if (data.success) {
          setContactesTreball(data.contactes || []);
        } else {
          console.error("Error carregant contactesTreball:", data.message);
        }
      } catch (err) {
        console.error("Error al fetchContactesTreball:", err);
      }
    };
    if (treballRelId) {
      fetchContactesTreball();
    }

  }, [mode, treballRel, treballRelId, adrecaModificada, empresaSeleccionada]);

  useEffect(() => {
    if (!treballRelId) {
      setTreballRel(null);
      return;
    }
    if (Number(treballRel?.idTreballs) === Number(treballRelId)) return;
    const local = treballsClient.find((t) => Number(t.idTreballs) === Number(treballRelId));
    if (local) {
      setTreballRel(local);
      return;
    }
    let cancelat = false;
    (async () => {
      try {
        const resp = await fetch(`${API_URL}/Treballs.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            idEmpresa: empresaSeleccionada?.IdEmpresa,
            idTreballs: treballRelId,
          }),
        });
        const data = await resp.json();
        if (!cancelat && data.success && data.treballs?.[0]) {
          setTreballRel(data.treballs[0]);
        }
      } catch (err) {
        console.error("Error carregant el treball relacionat:", err);
      }
    })();
    return () => {
      cancelat = true;
    };
  }, [treballRelId, treballsClient, treballRel, empresaSeleccionada]);

  // Omple els camps de contacte principal només a l'alta (copiant d'un Treball relacionat).
  // En consultar/modificar, les dades venen de Treballs.php (Preferent → CLIENT amb id més baix → Entitat).
  useEffect(() => {
    if (mode !== "nou") return;
    if (contactesTreball.length > 0) {
      const preferent = contactesTreball.find((ct) => Number(ct.ContactePreferent) === 1);
      const clientsRol = contactesTreball
        .filter((ct) => String(ct.RolTreball || "") === "CLIENT")
        .sort((a, b) => Number(a.idContactesTreballs) - Number(b.idContactesTreballs));
      const contacteDefault = preferent || clientsRol[0] || null;
      if (contacteDefault) {
        setNomContacteTreball(contacteDefault.Nom || "");
        setCognomContacteTreball(contacteDefault.Cognom1 || "");
        setTelefonContacteTreball(contacteDefault.Telefon || "");
        setEmailContacteTreball(contacteDefault.Email || "");
      }
    }
  }, [contactesTreball, mode]);

  // =================== Quan entrem en mode modificar/consultar/esborrar, omplim camps ===================
  useEffect(() => {
    if (mode === "nou" || !treball) {
      resetForm();
      const cid =
        clientInicial?.idClients ||
        (typeof clientInicial === "number" ? clientInicial : null);
      if (cid) setClientId(cid);
      return;
    }
    // Omplim tots els estats amb dades del treball
    // 1a Línia
    setClientId(treball.Clients_idClients || null);
    setContacteClientSeleccionat(treball.ContacteClient || null);
    setTreballRelId(treball.idTreballRelacionat || null);

    // 2a Línia (contacte preferent de treball)
    setNomContacteTreball(treball.NomContacteTreball || treball.PersonaContacte || "");
    setCognomContacteTreball(treball.CognomContacteTreball || "");
    setTelefonContacteTreball(treball.Telefon || "");
    setEmailContacteTreball(treball.Email || "");

    // 3a Línia
    setRolContacteTreball(treball.RolContacteTreball || "");
    setNotesContacteTreball(treball.NotesContacteTreball || "");
    setProfessio(treball.Professio || null);
    setProfessioDescripcio(treball.ProfessioDescripcio || "");

    // 4a-7a Línies
    setTipusVia(treball.TipusVia || "");
    setNomVia(treball.NomVia || "");
    setNumVia(treball.NumVia || "");
    setEscalaVia(treball.EscalaVia || "");
    setPis(treball.Pis || "");
    setPorta(treball.Porta || "");
    setPoblacio(treball.Poblacio || "");
    setProvincia(treball.Provincia || "");
    setPais(treball.Pais || "");
    setCodiPostal(treball.CodiPostal || "");
    setReferencies(treball.Referencies || "");

    // 8a Línia
    setPrioritatTreball(treball.PrioritatTreball || "");
    setTipusTreball(treball.TipusTreball || "");
    setEstatTreball(treball.Estat || "");
    setDataInici(aDataISO(treball.DiaInici));
    setDataFinal(aDataISO(treball.DiaFinal));
    setDataIniciPrevista(aDataISO(treball.DataIniciPrevista));
    setDataFinalPrevista(aDataISO(treball.DataFinalPrevista));

    // 9a Línia
    setDescripcio(treball.Descripcio || "");
    setHorari(treball.Horari || "");
  }, [mode, treball, clientInicial]);

  useEffect(() => {
    if (!treball?.idTreballs) {
      setTasquesCoherencia([]);
      return;
    }
    let cancelat = false;
    (async () => {
      try {
        const resp = await fetch(`${API_URL}/TasquesTreball.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ idTreballs: treball.idTreballs }),
        });
        const data = await resp.json();
        if (!cancelat && data.success) {
          setTasquesCoherencia(data.tasques || []);
        }
      } catch (err) {
        if (!cancelat) setTasquesCoherencia([]);
      }
    })();
    return () => {
      cancelat = true;
    };
  }, [treball?.idTreballs]);

  // =================== RESET FORM (nou) ===================
  const resetForm = useCallback(() => {
    // 1a Línia
    setClientId(null);
    setContacteClientSeleccionat(null);
    setTreballRelId(null);
    setTreballRel(null);

    // 2a Línia
    setNomContacteTreball("");
    setCognomContacteTreball("");
    setTelefonContacteTreball("");
    setEmailContacteTreball("");
    setVincularContacteClient(false);
    setModificarAdrecaContacte(false);

    // 3a Línia
    setRolContacteTreball("");
    setNotesContacteTreball("");
    setProfessio(null);
    setProfessioDescripcio("");

    setTipusTreball("Reparacio");
    setEstatTreball("Pendent");

    // 4a-7a
    setTipusVia("");
    setNomVia("");
    setNumVia("");
    setEscalaVia("");
    setPis("");
    setPorta("");
    setPoblacio("");
    setProvincia("");
    setPais("");
    setCodiPostal("");
    setReferencies("");
    setAdrecaModificada(false);

    // 8a Línia
    setPrioritatTreball("Mitjana");
    setDataIniciPrevista("");
    setDataFinalPrevista("");
    setDataInici("");
    setDataFinal("");

    // 9a Línia
    setDescripcio("");
    setHorari("");
  }, []);


  // Funció per inicialitzar l'adreça amb la del client seleccionat
  const inicialitzarAdrecaClient = (client) => {
    if (!client || adrecaModificada) return; // Si no hi ha client o l'usuari ha modificat manualment, no fem res
    // Si els camps són buits, els inicialitzem amb l'adreça del client
    setTipusViaDefault(client.TipusVia || "");
    setNomViaDefault(client.NomVia || "");
    setNumViaDefault(client.NumVia || "");
    setEscalaViaDefault(client.EscalaVia || "");
    setPisDefault(client.Pis || "");
    setPortaDefault(client.Porta || "");
    setPoblacioDefault(client.Poblacio || "");
    setProvinciaDefault(client.Provincia || "");
    setPaisDefault(client.Pais || "");
    setCodiPostalDefault(client.CodiPostal || "");
    setReferenciesDefault(client.Referencies || "");
  };

  // Funció per inicialitzar l'adreça amb la del treball relacionat seleccionat
  const inicialitzarAdrecaTreballRel = (treballRel) => {
    if (!treballRel || adrecaModificada) return; // Si no hi ha treballRel o l'usuari ha modificat manualment, no fem res
    // Si els camps són buits, els inicialitzem amb l'adreça del treballRel
    setTipusViaDefault(treballRel.TipusVia || "");
    setNomViaDefault(treballRel.NomVia || "");
    setNumViaDefault(treballRel.NumVia || "");
    setEscalaViaDefault(treballRel.EscalaVia || "");
    setPisDefault(treballRel.Pis || "");
    setPortaDefault(treballRel.Porta || "");
    setPoblacioDefault(treballRel.Poblacio || "");
    setProvinciaDefault(treballRel.Provincia || "");
    setPaisDefault(treballRel.Pais || "");
    setCodiPostalDefault(treballRel.CodiPostal || "");
    setReferenciesDefault(treballRel.Referencies || "");
  };


  // =================== VALIDACIÓ ===================
  const validarFormulari = () => {
    const errors = [];
    if (!clientId) errors.push("Has de seleccionar un Client.");

    // Validació Nou Contacte Client
    if (nouContacteClientActiu) {
      if (!nomNouContacteClient && !cognom1NouContacteClient) {
        errors.push("Nou Contacte Client: Cal indicar com a mínim Nom o 1r Cognom.");
      }
      if (!telefonNouContacteClient && !emailNouContacteClient) {
        errors.push("Nou Contacte Client: Cal indicar com a mínim Telèfon o Email.");
      }
    }

    // Validació Contacte preferent (nom/tel només si se'n crea un de nou)
    if (coordinacioActiu && !idPreferentExistent) {
      if (!nomCoordinacio && !cognom1Coordinacio) {
        errors.push("Contacte preferent: Cal indicar com a mínim Nom o 1r Cognom.");
      }
      if (!telefonCoordinacio && !emailCoordinacio) {
        errors.push("Contacte preferent: Cal indicar com a mínim Telèfon o Email.");
      }
    }

    const iniciOperatiu = dataInici || dataIniciPrevista;
    const finalOperatiu = dataFinal || dataFinalPrevista;
    if (estatTreball === "Acabat") {
      if (!dataInici) errors.push("Un Treball acabat ha de tenir data d'inici.");
      if (!dataFinal) errors.push("Un Treball acabat ha de tenir data final.");
    }
    if (dataInici && dataFinal && dataFinal < dataInici) {
      errors.push("La data final no pot ser anterior a la data d'inici.");
    } else if (!dataInici && !dataFinal && dataIniciPrevista && dataFinalPrevista && dataFinalPrevista < dataIniciPrevista) {
      errors.push("La data final prevista no pot ser anterior a la data d'inici prevista.");
    } else if (iniciOperatiu && finalOperatiu && finalOperatiu < iniciOperatiu) {
      errors.push("La data final no pot ser anterior a la data d'inici.");
    }

    return errors;
  };

  const handleCanviEstat = (nouEstat) => {
    setEstatTreball(nouEstat);
    if (nouEstat === "Pendent") {
      setDataInici("");
      setDataFinal("");
      return;
    }
    if (nouEstat === "En curs") {
      setDataInici((actual) => actual || avuiLocalISO());
      setDataFinal("");
      return;
    }
    if (nouEstat === "Acabat") {
      setDataFinal((actual) => actual || avuiLocalISO());
      setDataInici((actual) => {
        if (actual) return actual;
        const datesTasca = tasquesCoherencia
          .map((t) => aDataISO(t.DataInici))
          .filter(Boolean)
          .sort();
        if (datesTasca[0]) return datesTasca[0];
        if (dataIniciPrevista) return dataIniciPrevista;
        return avuiLocalISO();
      });
    }
  };

  const handleCanviInici = (valor) => {
    if (dataInici) {
      if (valor) setDataInici(valor);
    } else {
      setDataIniciPrevista(valor);
    }
  };

  const handleCanviFinal = (valor) => {
    if (dataFinal) {
      if (valor) setDataFinal(valor);
    } else {
      setDataFinalPrevista(valor);
    }
  };

  // Actualitzem desplegables
  useEffect(() => {
    setFilteredOptionsProfessions(professionsOptions);
  }, [professionsOptions]);

  // =================== SUBMIT (Crear, Modificar, Esborrar) ===================

  // Helper per fer submit real
  const executeSubmit = async (payloadModificat) => {
    // Si passem payload, l'usem, sinó construïm el basic
    const treballData = payloadModificat || {};

    // Construcció bàsica si no ve donada (pels camps comuns)
    // ... Nota: Millor construir-ho tot aquí unificant els resolved

    // Recuperem IDs o Dades dels resolved o dels estats
    // CONTACTE CLIENT:
    // Si tenim 'contacteClientSeleccionat' (dropdown) -> Prioritat.
    // Si 'nouContacteClientActiu' -> Usem 'resolvedContacteClient' (que pot ser {id...} o {nom...})
    let finalContacteClient = null;
    let finalNouContacteClientData = null;

    if (contacteClientSeleccionat) {
      finalContacteClient = contacteClientSeleccionat;
    } else if (nouContacteClientActiu) {
      // Pot ser que l'usuari hagi triat un existent al modal (resolved té id)
      // o que sigui nou (resolved té dades o és null i agafem estats)
      if (resolvedContacteClient && resolvedContacteClient.idContactes) {
        finalContacteClient = resolvedContacteClient.idContactes;
      } else {
        // És nou de trinca
        finalNouContacteClientData = {
          Nom: nomNouContacteClient,
          Cognom1: cognom1NouContacteClient,
          Cognom2: cognom2NouContacteClient,
          Telefon: telefonNouContacteClient,
          Email: emailNouContacteClient
        };
      }
    }

    // CONTACTE COORDINACIÓ:
    let finalContacteCoordinacio = null; // ID si existeix -> Vincular
    let finalNouContacteCoordinacioData = null; // Dades si és nou

    if (coordinacioActiu) {
      if (idPreferentExistent) {
        finalContacteCoordinacio = Number(idPreferentExistent);
      } else if (resolvedContacteCoordinacio && resolvedContacteCoordinacio.idContactes) {
        finalContacteCoordinacio = resolvedContacteCoordinacio.idContactes;
      } else {
        finalNouContacteCoordinacioData = {
          Nom: nomCoordinacio,
          Cognom1: cognom1Coordinacio,
          Cognom2: cognom2Coordinacio,
          Telefon: telefonCoordinacio,
          Email: emailCoordinacio,
          indicarAdreca: indicarAdrecaPreferent,
          adreca: indicarAdrecaPreferent
            ? {
                TipusVia: adrecaPreferent.TipusVia || adrecaTreballEfectiva().TipusVia,
                NomVia: adrecaPreferent.NomVia || adrecaTreballEfectiva().NomVia,
                NumVia: adrecaPreferent.NumVia || adrecaTreballEfectiva().NumVia,
                EscalaVia: adrecaPreferent.EscalaVia || adrecaTreballEfectiva().EscalaVia,
                Pis: adrecaPreferent.Pis || adrecaTreballEfectiva().Pis,
                Porta: adrecaPreferent.Porta || adrecaTreballEfectiva().Porta,
                Poblacio: adrecaPreferent.Poblacio || adrecaTreballEfectiva().Poblacio,
                Provincia: adrecaPreferent.Provincia || adrecaTreballEfectiva().Provincia,
                Pais: adrecaPreferent.Pais || adrecaTreballEfectiva().Pais,
                CodiPostal: adrecaPreferent.CodiPostal || adrecaTreballEfectiva().CodiPostal,
                Referencies: adrecaPreferent.Referencies || adrecaTreballEfectiva().Referencies,
              }
            : null,
        };
      }
    }

    const payload = {
      idEmpresa: empresaSeleccionada?.IdEmpresa || 0,
      idTreballs: treball?.idTreballs || null,
      Clients_idClients: clientId,
      Pressupostos_idPressupostos: treball?.Pressupostos_idPressupostos || null,
      TreballRelId: treballRelId || null,

      // CONTACTES
      ContacteClientExistingId: finalContacteClient,
      ContacteClientNewData: finalNouContacteClientData,
      NotesContacteTreball: notesContacteTreball,

      ContacteCoordinacioExistingId: finalContacteCoordinacio,
      ContacteCoordinacioNewData: finalNouContacteCoordinacioData,
      CoordinacioActiu: coordinacioActiu,
      RolCoordinacio: rolCoordinacio,
      VincularContacteClient: true,

      // ADREÇA
      TipusVia: tipusVia || tipusViaDefault,
      NomVia: nomVia || nomViaDefault,
      NumVia: numVia || numViaDefault,
      EscalaVia: escalaVia || escalaViaDefault,
      Pis: pis || pisDefault,
      Porta: porta || portaDefault,
      Poblacio: poblacio || poblacioDefault,
      Provincia: provincia || provinciaDefault,
      Pais: pais || paisDefault,
      CodiPostal: codiPostal || codiPostalDefault,
      Referencies: referencies || referenciesDefault,

      TipusTreball: tipusTreball,
      Estat: estatTreball,
      Prioritat: prioritatTreball,
      DiaInici: dataInici,
      DiaFinal: dataFinal,
      DataIniciPrevista: dataIniciPrevista,
      DataFinalPrevista: dataFinalPrevista,
      Descripcio: descripcio,
      Horari: horari,
      Usuari: usuariActiu,
    };

    // CALL API
    try {
      let endpoint, payloadData;

      if (mode === "esborrar") {
        endpoint = "Esborrartreball.php";
        payloadData = { idTreballs: treball.idTreballs };
      } else {
        endpoint = mode === "nou" ? "NouTreball.php" : "ModificarTreball.php";
        payloadData = payload;
        if (mode !== "nou") {
          delete payloadData.ContacteClientExistingId;
          delete payloadData.ContacteClientNewData;
          delete payloadData.NotesContacteTreball;
          delete payloadData.ContacteCoordinacioExistingId;
          delete payloadData.ContacteCoordinacioNewData;
          delete payloadData.CoordinacioActiu;
          delete payloadData.RolCoordinacio;
          delete payloadData.VincularContacteClient;
        }
      }

      const resp = await fetch(`${API_URL}/${endpoint}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payloadData),
      });
      const data = await resp.json();
      if (data.success) {
        if (mode === "esborrar") {
          alert("Treball esborrat correctament!");
          onCancel?.(); // Tanquem el formulari
        } else {
          alert(mode === "nou" ? "Treball creat!" : "Treball modificat!");
          if (mode === "nou") resetForm();
          onSave?.(data.newTreball || payload);
        }
      } else {
        alert("Error: " + data.message);
      }
    } catch (e) {
      console.error("Error submit:", e);
      alert("Error de connexió");
    }
  };

  // Funció Check Duplicates Async
  const checkDuplicates = async (dades) => {
    try {
      const resp = await fetch(`${API_URL}/Buscarcontacte.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          idEmpresa: empresaSeleccionada?.IdEmpresa,
          nom: dades.Nom,
          cognom1: dades.Cognom1,
          telefon: dades.Telefon,
          email: dades.Email
        })
      });
      const data = await resp.json();
      if (data.success && (data.contactes?.length > 0)) {
        return data.contactes;
      }
      return null;
    } catch (e) { return null; }
  };

  // MAIN HANDLER
  const handleSubmit = async () => {
    const errors = validarFormulari();
    if (errors.length > 0) {
      alert("Errors:\n" + errors.join("\n"));
      return;
    }

    if (
      mode !== "nou" &&
      estatTreball === "Acabat" &&
      tasquesCoherencia.some((t) => t.TipusTasca === "Ciclica" && t.Estat !== "Acabat")
    ) {
      const ok = window.confirm(
        "Acabar aquest Treball aturarà la generació de noves tasques cícliques. Les tasques cícliques pendents es tancaran sense generar-ne de noves. Vols continuar?"
      );
      if (!ok) return;
    }

    // PAS 1: Check Client Duplicate (si és nou i actiu)
    if (nouContacteClientActiu && !contacteClientSeleccionat) {
      const dups = await checkDuplicates({
        Nom: nomNouContacteClient,
        Cognom1: cognom1NouContacteClient,
        Telefon: telefonNouContacteClient,
        Email: emailNouContacteClient
      });
      if (dups) {
        setDedupContactes(dups);
        setDedupContext('client');
        setShowDedupModal(true);
        return; // STOP i esperar modal
      }
    }

    // PAS 2: Check Coordinacio Duplicate (si és actiu)
    // NOTA: Segons requeriment, això és automàtic. No parem, resolvem.
    if (coordinacioActiu && !idPreferentExistent) {
      const dups = await checkDuplicates({
        Nom: nomCoordinacio,
        Cognom1: cognom1Coordinacio,
        Telefon: telefonCoordinacio,
        Email: emailCoordinacio
      });
      if (dups) {
        setDedupContactes(dups);
        setDedupContext('coordinacio');
        setShowDedupModal(true);
        return;
      }
    }

    // PAS 3: Procedir (si hem arribat aquí, el client no tenia dups o estava ja seleccionat)
    if (mode === "esborrar") {
      setShowDeleteTreballModal(true);
    } else {
      executeSubmit();
    }
  };

  // Handlers Modal Dedup (pels casos manuals, ie. Client)
  const handleDedupSelect = (contacte) => {
    if (dedupContext === 'client') {
      setResolvedContacteClient(contacte);
    } else if (dedupContext === 'coordinacio') {
      setResolvedContacteCoordinacio(contacte);
    }
    setShowDedupModal(false);
    if (dedupContext === 'client') continueAfterClientDedup();
    else executeSubmit();
  };

  const handleDedupNew = () => {
    if (dedupContext === 'client') {
      setResolvedContacteClient(null);
    } else if (dedupContext === 'coordinacio') {
      setResolvedContacteCoordinacio(null);
    }
    setShowDedupModal(false);
    if (dedupContext === 'client') continueAfterClientDedup();
    else executeSubmit();
  };

  const continueAfterClientDedup = async () => {
    if (coordinacioActiu && !idPreferentExistent) {
      const dups = await checkDuplicates({
        Nom: nomCoordinacio,
        Cognom1: cognom1Coordinacio,
        Telefon: telefonCoordinacio,
        Email: emailCoordinacio
      });
      if (dups) {
        setDedupContactes(dups);
        setDedupContext('coordinacio');
        setShowDedupModal(true);
        return;
      }
    }
    executeSubmit();
  };

  // =================== HANDLERS AUXILIARS ===================


  // Obrir modal per professió (alta o modif)
  const handleOpenModal = (descripcio, modeAltaOModif) => {
    if (!descripcio.trim()) {
      alert("La descripció no pot estar buida.");
      return;
    }
    setDescription(descripcio);
    setIsModification(modeAltaOModif === "modif");
    setShowModal(true);
  };

  const handleTreballSelect = (treball) => {
    setSelectedTreball((prevTreball) =>
      prevTreball && prevTreball.idTreballs === treball.idTreballs ? null : treball
    );
  };

  // Guardar o modificar professió
  const handleSaveModal = async () => {
    try {
      if (isModification) {
        if (!newDescription.trim()) {
          alert("La nova descripció no pot estar buida.");
          return;
        }
        const response = await fetch(
          `${API_URL}/Modificaprofessions.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: professio,
              newDescription,
            }),
          }
        );
        const data = await response.json();
        if (data.success) {
          alert("La professió s'ha modificat correctament.");
          fetchProfessions();
          setProfessioDescripcio(newDescription);
        } else {
          alert(`Error modificant professions: ${data.message}`);
        }
      } else {
        if (!description.trim()) {
          alert("La descripció no pot estar buida.");
          return;
        }
        const response = await fetch(
          `${API_URL}/Altaprofessions.php`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ description }),
          }
        );
        const data = await response.json();
        if (data.success) {
          alert("La professió s'ha creat correctament.");
          fetchProfessions();
          const Idretornat = parseInt(data.id, 10);
          if (mode !== "nou") { treball.Professions_idProfessions = Idretornat };
          setProfessio(Idretornat);
          setProfessioDescripcio(description);
        } else {
          alert(`Error creant professions: ${data.message}`);
        }
      }
      setShowModal(false);
    } catch (error) {
      console.error("Error al gestionar el modal:", error);
      alert("Hi ha hagut un error. Torna-ho a intentar.");
    }
  };




  // =================== RENDERS (v2: dv2-card + dv2-fields) ===================
  const camp = (label, required, content, mida = "mig", comA = "label") => {
    const extra =
      mida === "ample"
        ? "dv2-field--ample"
        : mida === "llarg"
        ? "dv2-field--llarg"
        : mida === "curt"
        ? "dv2-field--curt"
        : "dv2-field--mig";
    const Tag = comA === "div" ? "div" : "label";
    return (
      <Tag className={`dv2-field ${extra}`}>
        <span className={`dv2-label ${required && !isReadOnly ? "dv2-required" : ""}`}>{label}</span>
        {content}
      </Tag>
    );
  };

  const valor = (txt) => <span className="dv2-value">{txt || "—"}</span>;

  const check = (label, checked, onChange, disabled = false) =>
    camp(
      label,
      false,
      <span className="dv2-toggleRow">
        <span className="dv2-toggle">
          <input type="checkbox" checked={!!checked} disabled={disabled} onChange={onChange} />
          <span className="dv2-toggle-track" />
        </span>
      </span>,
      "curt"
    );

  const toggleLinia = (label, checked, onChange, disabled = false) => (
    <label className="dv2-toggleRow">
      <span className="dv2-toggle">
        <input type="checkbox" checked={!!checked} disabled={disabled} onChange={onChange} />
        <span className="dv2-toggle-track" />
      </span>
      <span>{label}</span>
    </label>
  );

  const inputAdreca = (valorCamp, defecte, setValor, setDefecte, maxLength) => {
    const esTrans = valorCamp === "" && !!defecte;
    return (
      <input
        type="text"
        className={`dv2-input${esTrans ? " is-placeholder" : ""}`}
        value={valorCamp || defecte}
        maxLength={maxLength}
        onChange={(e) => {
          const v = e.target.value;
          if (valorCamp === "" && defecte) {
            setValor(v.replace(defecte, ""));
            setDefecte("");
            setAdrecaModificada(true);
          } else {
            setValor(v);
          }
        }}
        onClick={(e) => {
          if (valorCamp === "" && defecte) e.target.setSelectionRange(0, 0);
        }}
      />
    );
  };

  const adrecaTreballEfectiva = () => ({
    TipusVia: tipusVia || tipusViaDefault || "",
    NomVia: nomVia || nomViaDefault || "",
    NumVia: numVia || numViaDefault || "",
    EscalaVia: escalaVia || escalaViaDefault || "",
    Pis: pis || pisDefault || "",
    Porta: porta || portaDefault || "",
    Poblacio: poblacio || poblacioDefault || "",
    Provincia: provincia || provinciaDefault || "",
    Pais: pais || paisDefault || "",
    CodiPostal: codiPostal || codiPostalDefault || "",
    Referencies: referencies || referenciesDefault || "",
  });

  const inputAdrecaContacte = (campNom, maxLength) => {
    const defecte = adrecaTreballEfectiva()[campNom] || "";
    const valorCamp = adrecaPreferent[campNom] || "";
    const esTrans = valorCamp === "" && !!defecte;
    return (
      <input
        type="text"
        className={`dv2-input${esTrans ? " is-placeholder" : ""}`}
        value={valorCamp || defecte}
        maxLength={maxLength}
        onChange={(e) => {
          const v = e.target.value;
          if (valorCamp === "" && defecte) {
            setAdrecaPreferent((p) => ({ ...p, [campNom]: v.replace(defecte, "") }));
          } else {
            setAdrecaPreferent((p) => ({ ...p, [campNom]: v }));
          }
        }}
        onClick={(e) => {
          if (valorCamp === "" && defecte) e.target.setSelectionRange(0, 0);
        }}
      />
    );
  };

  const selectAdrecaContacteTipus = () => {
    const defecte = adrecaTreballEfectiva().TipusVia;
    const valorCamp = adrecaPreferent.TipusVia || "";
    const esTrans = valorCamp === "" && !!defecte;
    return (
      <select
        className={`dv2-select${esTrans ? " is-placeholder" : ""}`}
        value={valorCamp || defecte}
        onChange={(e) => setAdrecaPreferent((p) => ({ ...p, TipusVia: e.target.value }))}
      >
        <option value="">Selecciona un tipus de via</option>
        {Object.keys(mapejos.tipusVia).map((option) => (
          <option key={option} value={option}>
            {mapToPresentable(option, mapejos.tipusVia)}
          </option>
        ))}
      </select>
    );
  };

  const selectAdrecaTipus = () => {
    const esTrans = tipusVia === "" && !!tipusViaDefault;
    return (
      <select
        className={`dv2-select${esTrans ? " is-placeholder" : ""}`}
        value={tipusVia || tipusViaDefault}
        onChange={(e) => {
          const v = e.target.value;
          if (tipusVia === "" && tipusViaDefault !== "") {
            setTipusVia(v);
            setTipusViaDefault("");
            setAdrecaModificada(true);
          } else {
            setTipusVia(v);
          }
        }}
      >
        <option value="">Selecciona un tipus de via</option>
        {Object.keys(mapejos.tipusVia).map((option) => (
          <option key={option} value={option}>
            {mapToPresentable(option, mapejos.tipusVia)}
          </option>
        ))}
      </select>
    );
  };

  const formatClientName = () => {
    if (!clientId) return "—";
    const found = clientsOptions.find((c) => c.idClients === clientId);
    return found ? found.NomClient : "—";
  };

  const formatContactName = () => {
    const nom = [nomContacteTreball, cognomContacteTreball].filter(Boolean).join(" ").trim();
    return nom || "—";
  };

  const etiquetaTreballRelacionat = (t) => {
    if (!t) return "";
    return [t.idTreballIntern, t.NomClient, t.Descripcio].filter(Boolean).join(" · ");
  };

  const etiquetaData = (real, etiqueta) => (real ? etiqueta : `${etiqueta} (previst)`);
  const textData = (real, prevista) => {
    const valorData = real || prevista;
    if (!valorData) return "—";
    let t = formatDate(valorData) || "—";
    if (real && prevista && aDataISO(prevista) !== aDataISO(real)) {
      t += ` (previst: ${formatDate(prevista)})`;
    }
    return t;
  };

  const renderModal = () => (
    <>
      {showModal && (
        <div className="dv2-modalOverlay" role="dialog" aria-modal="true">
          <div className="dv2-modal">
            <h3 className="dv2-modal-title">
              {isModification ? "Modifica la professió" : "Afegeix una nova professió"}
            </h3>
            {isModification ? (
              <>
                <p className="dv2-modal-lead">
                  Modifica la descripció de <strong>{description}</strong>:
                </p>
                <input
                  type="text"
                  maxLength={100}
                  className="dv2-input"
                  value={newDescription}
                  onChange={(e) => setNewDescription(e.target.value)}
                  placeholder="Nova descripció"
                />
              </>
            ) : (
              <p className="dv2-modal-lead">
                Estàs donant d'alta una nova <strong>professió</strong> amb la descripció{" "}
                <strong>{description}</strong>.
              </p>
            )}
            <div className="dv2-modal-actions">
              <button type="button" className="dv2-btn" onClick={() => setShowModal(false)}>
                Cancel·la
              </button>
              <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSaveModal}>
                {isModification ? "Modifica" : "Crea"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showDedupModal && (
        <div className="dv2-modalOverlay" role="dialog" aria-modal="true">
          <div className="dv2-modal">
            <h3 className="dv2-modal-title">Possibles contactes duplicats</h3>
            <p className="dv2-modal-lead">
              Hem trobat contactes semblants. Vols seleccionar-ne un o crear-ne un de nou?
            </p>
            <ul className="dv2-specList" style={{ marginBottom: 12 }}>
              {dedupContactes.map((c) => (
                <li key={c.idContactes} className="dv2-spec">
                  <span className="dv2-spec-name">
                    {c.Nom} {c.Cognom1} — {c.Telefon} — {c.Email}
                  </span>
                  <button type="button" className="dv2-btn dv2-btn--compact" onClick={() => handleDedupSelect(c)}>
                    Seleccionar
                  </button>
                </li>
              ))}
            </ul>
            <div className="dv2-modal-actions">
              <button type="button" className="dv2-btn" onClick={() => setShowDedupModal(false)}>
                Cancel·la
              </button>
              <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleDedupNew}>
                Crear de nou
              </button>
            </div>
          </div>
        </div>
      )}

      {showDeleteTreballModal && (
        <div className="dv2-modalOverlay" role="dialog" aria-modal="true">
          <div className="dv2-modal">
            <h3 className="dv2-modal-title">Confirmar esborrat</h3>
            <p className="dv2-modal-lead">Estàs segur que vols esborrar aquest treball?</p>
            <div className="dv2-modal-actions">
              <button type="button" className="dv2-btn" onClick={() => setShowDeleteTreballModal(false)}>
                No
              </button>
              <button
                type="button"
                className="dv2-btn dv2-btn--danger"
                onClick={() => {
                  setShowDeleteTreballModal(false);
                  executeSubmit();
                }}
              >
                Sí, esborrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );

  const renderCamps = () => {
    const showNouContacteClient = !contacteClientSeleccionat && !!clientId;
    const qPref = filtrePreferent.trim().toLowerCase();
    const preferentsFiltrats = contactesEmpresa.filter((c) => {
      if (!qPref) return true;
      const blob = `${c.NomMostrar || ""} ${c.Nom || ""} ${c.Cognom1 || ""} ${c.Telefon || ""} ${c.Email || ""}`.toLowerCase();
      return blob.includes(qPref);
    });

    return (
      <>
        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">1</span>
            <h2 className="dv2-card-title">Client i contactes</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {isReadOnly ? (
              <>
                {camp("Client", false, valor(formatClientName()), "llarg")}
                {nomContacteTreball ? camp("Contacte", false, valor(formatContactName()), "llarg") : null}
                {telefonContacteTreball ? camp("Telèfon", false, valor(telefonContacteTreball)) : null}
                {emailContacteTreball ? camp("Email", false, valor(emailContacteTreball), "llarg") : null}
                {camp("Treball relacionat", false, valor(etiquetaTreballRelacionat(treballRel) || "—"), "llarg")}
              </>
            ) : (
              <>
                {camp(
                  "Cerca client",
                  false,
                  <input
                    type="text"
                    className="dv2-input"
                    value={filtreClient}
                    onChange={(e) => setFiltreClient(e.target.value)}
                    placeholder="Escriu per filtrar…"
                  />
                )}
                {camp(
                  "Client",
                  true,
                  <div className="dv2-controlRow">
                    <select
                      className="dv2-select"
                      value={clientId || ""}
                      onChange={(e) => setClientId(Number(e.target.value) || null)}
                    >
                      <option value="">— Selecciona un client —</option>
                      {clientsFiltrats.map((cli) => (
                        <option key={cli.idClients} value={cli.idClients}>
                          {cli.NomClient}
                        </option>
                      ))}
                    </select>
                    {mode === "nou" && onNouClient && pucCrear ? (
                      <button type="button" className="dv2-btn dv2-btn--compact" onClick={onNouClient}>
                        + Nou client
                      </button>
                    ) : null}
                  </div>,
                  "llarg"
                )}
                {contactesClient.length > 0 &&
                  camp(
                    "Contacte (client)",
                    false,
                    <select
                      className="dv2-select"
                      value={contacteClientSeleccionat || ""}
                      onChange={(e) => setContacteClientSeleccionat(Number(e.target.value) || null)}
                    >
                      <option value="">— Opcional —</option>
                      {contactesClient.map((contacte) => (
                        <option key={contacte.idContacteClients} value={contacte.idContacteClients}>
                          {contacte.Nom} {contacte.Cognom1 || ""} {contacte.Email ? ` — ${contacte.Email}` : ""}
                        </option>
                      ))}
                    </select>,
                    "llarg"
                  )}
                {camp(
                  "Treball relacionat",
                  false,
                  <div className="dv2-controlRow">
                    <span className="dv2-value">
                      {etiquetaTreballRelacionat(treballRel) || "Cap treball seleccionat"}
                    </span>
                    <button type="button" className="dv2-btn dv2-btn--compact" onClick={() => setSeleccioTreball(true)}>
                      Cerca
                    </button>
                    {treballRelId ? (
                      <button
                        type="button"
                        className="dv2-btn dv2-btn--compact"
                        onClick={() => {
                          setTreballRel(null);
                          setTreballRelId(null);
                        }}
                      >
                        Treure
                      </button>
                    ) : null}
                  </div>,
                  "llarg",
                  "div"
                )}
              </>
            )}

            {mode === "nou" && (
              <>
                <span className="dv2-fields-break" aria-hidden="true" />
                <div className="dv2-field dv2-field--ample">
                  <div className="dv2-toggleGroup">
                    {toggleLinia(
                      "Nou contacte del client",
                      nouContacteClientActiu,
                      (e) => setNouContacteClientActiu(e.target.checked),
                      !showNouContacteClient || !clientId
                    )}
                    {toggleLinia(
                      "Contacte preferent (coordinació)",
                      coordinacioActiu,
                      (e) => setCoordinacioActiu(e.target.checked)
                    )}
                  </div>
                </div>
                {nouContacteClientActiu && (
                  <>
                    <span className="dv2-fields-break" aria-hidden="true" />
                    {camp("Nom", false, <input className="dv2-input" type="text" value={nomNouContacteClient} onChange={(e) => setNomNouContacteClient(e.target.value)} />)}
                    {camp("Cognom 1", false, <input className="dv2-input" type="text" value={cognom1NouContacteClient} onChange={(e) => setCognom1NouContacteClient(e.target.value)} />)}
                    {camp("Cognom 2", false, <input className="dv2-input" type="text" value={cognom2NouContacteClient} onChange={(e) => setCognom2NouContacteClient(e.target.value)} />)}
                    <span className="dv2-fields-break" aria-hidden="true" />
                    {camp("Telèfon", false, <input className="dv2-input" type="text" value={telefonNouContacteClient} onChange={(e) => setTelefonNouContacteClient(e.target.value)} />)}
                    {camp("Email", false, <input className="dv2-input" type="email" value={emailNouContacteClient} onChange={(e) => setEmailNouContacteClient(e.target.value)} />, "llarg")}
                    {camp("Notes", false, <input className="dv2-input" type="text" value={notesContacteTreball} onChange={(e) => setNotesContacteTreball(e.target.value)} />, "ample")}
                  </>
                )}
                {contacteClientSeleccionat && !nouContacteClientActiu &&
                  camp("Notes (contacte client)", false, <input className="dv2-input" type="text" value={notesContacteTreball} onChange={(e) => setNotesContacteTreball(e.target.value)} />, "ample")}
                {coordinacioActiu && (
                  <>
                    <span className="dv2-fields-break" aria-hidden="true" />
                    {camp("Cerca preferent", false, <input className="dv2-input" value={filtrePreferent} onChange={(e) => setFiltrePreferent(e.target.value)} placeholder="Nom, telèfon o email" />)}
                    {camp(
                      "Contacte existent",
                      false,
                      <select className="dv2-select" value={idPreferentExistent} onChange={(e) => setIdPreferentExistent(e.target.value)}>
                        <option value="">— Crear-ne un de nou —</option>
                        {preferentsFiltrats.map((c) => (
                          <option key={c.idContactes} value={c.idContactes}>
                            {c.NomMostrar}{c.Telefon ? ` · ${c.Telefon}` : ""}{c.Email ? ` · ${c.Email}` : ""}
                          </option>
                        ))}
                      </select>,
                      "llarg"
                    )}
                    {!idPreferentExistent && (
                      <>
                        {camp("Nom", false, <input className="dv2-input" type="text" value={nomCoordinacio} onChange={(e) => setNomCoordinacio(e.target.value)} />)}
                        {camp("Cognom 1", false, <input className="dv2-input" type="text" value={cognom1Coordinacio} onChange={(e) => setCognom1Coordinacio(e.target.value)} />)}
                        {camp("Cognom 2", false, <input className="dv2-input" type="text" value={cognom2Coordinacio} onChange={(e) => setCognom2Coordinacio(e.target.value)} />)}
                        <span className="dv2-fields-break" aria-hidden="true" />
                        {camp("Telèfon", false, <input className="dv2-input" type="text" value={telefonCoordinacio} onChange={(e) => setTelefonCoordinacio(e.target.value)} />)}
                        {camp("Email", false, <input className="dv2-input" type="email" value={emailCoordinacio} onChange={(e) => setEmailCoordinacio(e.target.value)} />, "llarg")}
                      </>
                    )}
                    {camp("Rol al treball", false, <input className="dv2-input" type="text" value={rolCoordinacio} onChange={(e) => setRolCoordinacio(e.target.value)} placeholder="Ex: Cap d'obra, veí…" />, "llarg")}
                    {!idPreferentExistent && check("Indicar adreça del contacte", indicarAdrecaPreferent, (e) => setIndicarAdrecaPreferent(e.target.checked))}
                    {!idPreferentExistent && indicarAdrecaPreferent && (
                      <>
                        <span className="dv2-fields-break" aria-hidden="true" />
                        {camp("Tipus de via", true, selectAdrecaContacteTipus())}
                        {camp("Nom de la via", true, inputAdrecaContacte("NomVia", 100), "llarg")}
                        {camp("Número", true, inputAdrecaContacte("NumVia", 15), "curt")}
                        {camp("Escala", false, inputAdrecaContacte("EscalaVia", 10), "curt")}
                        {camp("Pis", false, inputAdrecaContacte("Pis", 25), "curt")}
                        {camp("Porta", false, inputAdrecaContacte("Porta", 5), "curt")}
                        <span className="dv2-fields-break" aria-hidden="true" />
                        {camp("Població", true, inputAdrecaContacte("Poblacio", 100), "llarg")}
                        {camp("Província", true, inputAdrecaContacte("Provincia", 50))}
                        {camp("País", true, inputAdrecaContacte("Pais", 100))}
                        {camp("Codi postal", true, inputAdrecaContacte("CodiPostal", 10), "curt")}
                        {camp(
                          "Referències",
                          false,
                          <textarea
                            className={`dv2-textarea${!(adrecaPreferent.Referencies || "") && adrecaTreballEfectiva().Referencies ? " is-placeholder" : ""}`}
                            value={adrecaPreferent.Referencies || adrecaTreballEfectiva().Referencies}
                            maxLength={256}
                            onChange={(e) => {
                              const v = e.target.value;
                              const defecte = adrecaTreballEfectiva().Referencies;
                              if (!(adrecaPreferent.Referencies || "") && defecte) {
                                setAdrecaPreferent((p) => ({ ...p, Referencies: v.replace(defecte, "") }));
                              } else {
                                setAdrecaPreferent((p) => ({ ...p, Referencies: v }));
                              }
                            }}
                            onClick={(e) => {
                              if (!(adrecaPreferent.Referencies || "") && adrecaTreballEfectiva().Referencies) {
                                e.target.setSelectionRange(0, 0);
                              }
                            }}
                          />,
                          "ample"
                        )}
                      </>
                    )}
                  </>
                )}
              </>
            )}

            {mode === "modificar" && (
              <div className="dv2-field dv2-field--ample">
                <p className="dv2-hint">Els contactes d'aquest treball es gestionen a la pestanya Contactes.</p>
              </div>
            )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">2</span>
            <h2 className="dv2-card-title">Descripció</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {camp(
              "Descripció del treball",
              false,
              isReadOnly ? (
                valor(descripcio)
              ) : (
                <textarea className="dv2-textarea" value={descripcio} rows={3} onChange={(e) => setDescripcio(e.target.value)} />
              ),
              "ample"
            )}
            {isReadOnly
              ? (horari.trim() ? camp("Horari", false, valor(horari), "ample") : null)
              : camp(
                  "Horari",
                  false,
                  <input
                    className="dv2-input"
                    type="text"
                    value={horari}
                    maxLength={255}
                    onChange={(e) => setHorari(e.target.value)}
                  />,
                  "ample"
                )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">3</span>
            <h2 className="dv2-card-title">Classificació</h2>
          </div>
          <div className="dv2-fields dv2-fields--sizes">
            {isReadOnly ? (
              <>
                {camp("Tipus", false, valor(mapToPresentable(tipusTreball, mapejos.tipusTreballMap) || tipusTreball))}
                {camp("Estat", false, valor(estatTreball))}
                {camp("Prioritat", false, valor(prioritatTreball))}
                {camp("Pressupost", false, valor(treball?.idPresIntern))}
                {camp(etiquetaData(dataInici, "Inici"), false, valor(textData(dataInici, dataIniciPrevista)))}
                {camp(etiquetaData(dataFinal, "Final"), false, valor(textData(dataFinal, dataFinalPrevista)))}
              </>
            ) : (
              <>
                {camp(
                  "Tipus de treball",
                  false,
                  <select className="dv2-select" value={tipusTreball} onChange={(e) => setTipusTreball(e.target.value)}>
                    {Object.entries(mapejos.tipusTreballMap).map(([key, label]) => (
                      <option key={key} value={key}>{label}</option>
                    ))}
                  </select>
                )}
                {camp(
                  "Estat",
                  false,
                  <select
                    className="dv2-select"
                    value={estatTreball}
                    onChange={(e) => handleCanviEstat(e.target.value)}
                    disabled={mode === "nou"}
                  >
                    <option value="">— Selecciona estat —</option>
                    {estatOptions.map((t) => (
                      <option key={t} value={t}>{t}</option>
                    ))}
                  </select>
                )}
                {camp(
                  "Prioritat",
                  false,
                  <select className="dv2-select" value={prioritatTreball} onChange={(e) => setPrioritatTreball(e.target.value)}>
                    <option value="">— Selecciona prioritat —</option>
                    {prioritatsOptions.map((p) => (
                      <option key={p} value={p}>{p}</option>
                    ))}
                  </select>
                )}
                {camp(
                  etiquetaData(dataInici, "Inici"),
                  false,
                  <>
                    <input className="dv2-input" type="date" value={dataInici || dataIniciPrevista || ""} onChange={(e) => handleCanviInici(e.target.value)} />
                    {dataInici && dataIniciPrevista ? <span className="dv2-hint">Previst: {formatDate(dataIniciPrevista)}</span> : null}
                  </>
                )}
                {camp(
                  etiquetaData(dataFinal, "Final"),
                  false,
                  <>
                    <input className="dv2-input" type="date" value={dataFinal || dataFinalPrevista || ""} onChange={(e) => handleCanviFinal(e.target.value)} />
                    {dataFinal && dataFinalPrevista ? <span className="dv2-hint">Previst: {formatDate(dataFinalPrevista)}</span> : null}
                  </>
                )}
              </>
            )}
          </div>
        </section>

        <section className="dv2-card">
          <div className="dv2-card-head">
            <span className="dv2-card-num">4</span>
            <h2 className="dv2-card-title">Adreça</h2>
          </div>
          {isReadOnly ? (
            <div className="dv2-fields dv2-fields--sizes">
              {camp(
                "Adreça",
                false,
                valor(formatAddress({
                  TipusVia: tipusVia || tipusViaDefault,
                  NomVia: nomVia || nomViaDefault,
                  NumVia: numVia || numViaDefault,
                  EscalaVia: escalaVia || escalaViaDefault,
                  Pis: pis || pisDefault,
                  Porta: porta || portaDefault,
                  Poblacio: poblacio || poblacioDefault,
                  Provincia: provincia || provinciaDefault,
                  CodiPostal: codiPostal || codiPostalDefault,
                })),
                "ample"
              )}
              {(referencies || referenciesDefault)
                ? camp("Referències", false, valor(referencies || referenciesDefault), "ample")
                : null}
            </div>
          ) : (
            <div className="dv2-fields dv2-fields--sizes">
              {camp("Tipus de via", true, selectAdrecaTipus())}
              {camp("Nom de la via", true, inputAdreca(nomVia, nomViaDefault, setNomVia, setNomViaDefault, 100), "llarg")}
              {camp("Número", true, inputAdreca(numVia, numViaDefault, setNumVia, setNumViaDefault, 15), "curt")}
              {camp("Escala", false, inputAdreca(escalaVia, escalaViaDefault, setEscalaVia, setEscalaViaDefault, 10), "curt")}
              {camp("Pis", false, inputAdreca(pis, pisDefault, setPis, setPisDefault, 25), "curt")}
              {camp("Porta", false, inputAdreca(porta, portaDefault, setPorta, setPortaDefault, 5), "curt")}
              <span className="dv2-fields-break" aria-hidden="true" />
              {camp("Població", true, inputAdreca(poblacio, poblacioDefault, setPoblacio, setPoblacioDefault, 100), "llarg")}
              {camp("Província", true, inputAdreca(provincia, provinciaDefault, setProvincia, setProvinciaDefault, 50))}
              {camp("País", true, inputAdreca(pais, paisDefault, setPais, setPaisDefault, 100))}
              {camp("Codi postal", true, inputAdreca(codiPostal, codiPostalDefault, setCodiPostal, setCodiPostalDefault, 10), "curt")}
              {camp(
                "Referències",
                false,
                <textarea
                  className={`dv2-textarea${referencies === "" && referenciesDefault ? " is-placeholder" : ""}`}
                  value={referencies || referenciesDefault}
                  maxLength={256}
                  onChange={(e) => {
                    const v = e.target.value;
                    if (referencies === "" && referenciesDefault) {
                      setReferencies(v.replace(referenciesDefault, ""));
                      setReferenciesDefault("");
                      setAdrecaModificada(true);
                    } else {
                      setReferencies(v);
                    }
                  }}
                  onClick={(e) => {
                    if (referencies === "" && referenciesDefault) e.target.setSelectionRange(0, 0);
                  }}
                />,
                "ample"
              )}
            </div>
          )}
        </section>
      </>
    );
  };

  const titolFitxa =
    mode === "nou"
      ? "Nou treball"
      : mode === "esborrar"
      ? "Esborrar treball"
      : mode === "modificar"
      ? "Modificar treball"
      : "Treball";
  const subtitolFitxa = treball?.idTreballIntern
    ? `${treball.idTreballIntern}${treball.NomClient ? ` · ${treball.NomClient}` : ""}`
    : "Fitxa del treball";
  const potNavegar = mode === "consultar" && Array.isArray(treballs) && treballs.length > 1 && currentIndex >= 0;

  if (seleccioTreball) {
    return (
      <div className="dv2-entity">
        <div className="dv2-pageHeader">
          <div className="dv2-pageHeader-main">
            <div className="dv2-pageHeader-icon" aria-hidden="true">
              🛠️
            </div>
            <div>
              <h1 className="dv2-pageHeader-title">Treball relacionat</h1>
              <p className="dv2-pageHeader-subtitle">Tria un treball preexistent. Pot ser d'un altre client.</p>
            </div>
          </div>
          <div className="dv2-pageHeader-actions">
            <button
              type="button"
              className="dv2-btn"
              onClick={() => setSeleccioTreball(false)}
            >
              Cancel·lar
            </button>
            <button
              type="button"
              className="dv2-btn dv2-btn--primary"
              onClick={() => {
                if (!selectedTreball) return;
                if (treball?.idTreballs && Number(selectedTreball.idTreballs) === Number(treball.idTreballs)) {
                  alert("No pots relacionar un treball amb ell mateix.");
                  return;
                }
                setTreballRel(selectedTreball);
                setTreballRelId(selectedTreball?.idTreballs || null);
                setSeleccioTreball(false);
              }}
            >
              Seleccionar
            </button>
          </div>
        </div>
        <div className="dv2-entity-body">
          <Seleccionartreball
            onTreballSelect={handleTreballSelect}
            selectedTreball={selectedTreball}
            totsElsClients
            estatInicial=""
            excludeId={treball?.idTreballs}
          />
        </div>
      </div>
    );
  }

  return (
    <form className="dv2-entity" onSubmit={(e) => e.preventDefault()}>
      {mostraAjuda && <AjudaTreball pestanya="dades" onTancar={() => setMostraAjuda(false)} />}
      {renderModal()}
      <div className="dv2-pageHeader">
        <div className="dv2-pageHeader-main">
          <div className={`dv2-pageHeader-icon ${mode === "esborrar" ? "is-danger" : ""}`} aria-hidden="true">
            {mode === "esborrar" ? "🗑️" : "🛠️"}
          </div>
          <div>
            <h1 className="dv2-pageHeader-title">{titolFitxa}</h1>
            <p className="dv2-pageHeader-subtitle">{subtitolFitxa}</p>
          </div>
        </div>
        <div className="dv2-pageHeader-actions">
          <button
            type="button"
            className="dv2-btn dv2-btn--icon dv2-btn--ghost"
            title="Com funciona la fitxa del Treball"
            aria-label="Ajuda"
            onClick={() => setMostraAjuda(true)}
          >
            ?
          </button>
          <button type="button" className="dv2-btn" onClick={onCancel}>
            Tornar
          </button>
          {mode === "consultar" && pucModificar && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={() => onCanviarMode?.("modificar")}>
              Modificar
            </button>
          )}
          {mode === "consultar" && (
            <div style={{ position: "relative" }}>
              <button type="button" className="dv2-btn" onClick={() => setMenuAccions((v) => !v)}>
                Més accions
              </button>
              {menuAccions && (
                <div className="dv2-menu" style={{ right: 0, top: "42px" }}>
                  {pucModificar && (
                    <>
                      <button
                        type="button"
                        className="dv2-menu-item"
                        onClick={() => {
                          setMenuAccions(false);
                          onCanviarMode?.("tasques");
                        }}
                      >
                        Tasques
                      </button>
                      <button
                        type="button"
                        className="dv2-menu-item"
                        onClick={() => {
                          setMenuAccions(false);
                          onCanviarMode?.("contactes");
                        }}
                      >
                        Contactes
                      </button>
                      <button
                        type="button"
                        className="dv2-menu-item"
                        onClick={() => {
                          setMenuAccions(false);
                          onCanviarMode?.("ofertes");
                        }}
                      >
                        Ofertes
                      </button>
                      <button
                        type="button"
                        className="dv2-menu-item"
                        onClick={() => {
                          setMenuAccions(false);
                          onCanviarMode?.("resum");
                        }}
                      >
                        Resum
                      </button>
                    </>
                  )}
                  {pucEsborrarFitxa && (
                    <button
                      type="button"
                      className="dv2-menu-item is-danger"
                      onClick={() => {
                        setMenuAccions(false);
                        onCanviarMode?.("esborrar");
                      }}
                    >
                      Esborrar
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
          {(mode === "nou" || mode === "modificar") && (
            <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
              Desar
            </button>
          )}
          {mode === "esborrar" && (
            <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
              Esborrar treball
            </button>
          )}
        </div>
      </div>
      {subnav}

      {mode === "esborrar" && (
        <div className="dv2-banner dv2-banner--danger">
          Aquesta acció no es pot desfer. Si el treball té tasques o relacions, el servidor pot impedir l'esborrat.
        </div>
      )}

      <div className="dv2-entity-body">{renderCamps()}</div>

      {(potNavegar || mode === "nou" || mode === "modificar" || mode === "esborrar") && (
        <div className="dv2-entity-dock">
          {potNavegar && (
            <div className="dv2-recordNav">
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={anteriorTreball} title="Anterior">
                ‹
              </button>
              <span className="dv2-recordNav-info">
                {currentIndex + 1} / {treballs.length}
              </span>
              <button type="button" className="dv2-btn dv2-recordNav-btn" onClick={seguentTreball} title="Següent">
                ›
              </button>
            </div>
          )}
          {(mode === "nou" || mode === "modificar" || mode === "esborrar") && (
            <div className="dv2-footerActions">
              <button type="button" className="dv2-btn" onClick={onCancel}>
                Cancel·lar
              </button>
              {mode === "esborrar" ? (
                <button type="button" className="dv2-btn dv2-btn--danger" onClick={handleSubmit}>
                  Esborrar treball
                </button>
              ) : (
                <button type="button" className="dv2-btn dv2-btn--primary" onClick={handleSubmit}>
                  {mode === "nou" ? "Desar treball" : "Desar"}
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </form>
  );
}

export default Detallstreball;
